export type HostKind = "ios-webview" | "android-webview" | "iframe" | "none";

declare global {
  interface Window {
    webkit?: {
      messageHandlers?: {
        templateEditorAuth?: { postMessage: (message: unknown) => void };
      };
    };
    templateEditorAuth?: { postMessage: (message: string) => void };
    __onTemplateEditorAuth?: (payload: unknown) => void;
  }
}

/**
 * Which host is this app embedded in?
 *
 * Order matters: the native bridges are checked BEFORE the iframe test,
 * because a WebView can also satisfy `window.parent !== window` in some
 * embedding setups. If the iframe branch won there, the app would postMessage
 * at a parent that has no listener and hang until the request timed out.
 */
export function detectHost(): HostKind {
  if (window.webkit?.messageHandlers?.templateEditorAuth) return "ios-webview";
  if (window.templateEditorAuth) return "android-webview";
  if (window.parent !== window) return "iframe";
  return "none";
}
